module.exports = __webpack_public_path__ + "img/mailunsent.c85846aa.svg";